import { apiInstance } from "./networking";

export const getImage = async (payload) => {
  const { data = {} } = await apiInstance.post(
    `customer/selfie-upload/`,
    payload
  );
  return data;
};
